export const TILE_SIZE = 32;

export const SOLID_TILES: number[] = [];

export const VIEWPORT_WIDTH_TILES = 22;
export const VIEWPORT_HEIGHT_TILES = 12;

export const MOVE_SPEED = 220;

export const LOGICAL_W = VIEWPORT_WIDTH_TILES * TILE_SIZE;
export const LOGICAL_H = VIEWPORT_HEIGHT_TILES * TILE_SIZE;

export const MAX_INVENTORY = 5;